// eslint-disable-next-line no-redeclare
/* global window, $, document */

export default (() => {
  if (!(typeof window !== 'undefined' && typeof document !== 'undefined')) {
    return
  }

  window.addEventListener('load', function () {
    if (!(window.$ && $.fn && $.fn.docout)) {
      return
    }

    $('article .body').docout({ target: '.js-docout' })
    $('.docout-root-wrap li').addClass('list-group-item')
    $('.docout-root-wrap li a').on('click', function (e) {
      e.preventDefault()

      let height = $('body header').height() + 30
      let el = $(this.getAttribute('href'))[0]

      if (!el) return

      $(el).css('scroll-margin-top', height + 'px')
      el.scrollIntoView({
        behavior: 'smooth',
      })
    })
  })
})()
